// The idea of this component is to listen for a user click on the showcase or
// Treedis components (BurgerMenu, BottomBar, etc), and then call the setInteracted function
// As soon as 'interacted' is set to true in BaseTour, this component will be unmounted
// Currently there are other places in the codebase where interacted is set to true, but ideally in the future all interacted logic should be handled by this component

import { useCallback, useEffect, useRef } from 'react';

type Props = {
  showcase: any;
  onInteracted: () => void;
};

export const InteractedListener = ({ showcase, onInteracted }: Props): JSX.Element => {
  const eventRef = useRef(null);
  const isActiveRef = useRef(false);

  const handleClick = useCallback(() => {
    onInteracted();
  }, [onInteracted]);

  useEffect(() => {
    // When the tour starts, it will be 'inactive' at first, but when it starts playing it will be 'active', and when it becomes 'inactive' again, it means the user has interacted with the tour
    if (showcase && !eventRef.current) {
      eventRef.current = showcase.Tour.state.subscribe((state) => {
        if (!isActiveRef.current && state.current === 'tour.active') {
          isActiveRef.current = true;
          return;
        }

        if (state.current === 'tour.inactive' && isActiveRef.current) {
          handleClick();
        }
      });
    }

    return () => {
      eventRef.current?.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showcase]);

  useEffect(() => {
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
